// extracted by mini-css-extract-plugin
export default {"container":"page_container__+ElUN","indexContainer":"page_indexContainer__M0kY5"};